import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

import PlateHead from 'src/components/ui/PlateHead';
import StatusText from 'src/components/ui/StatusText';
import TypoEntry from 'src/components/ui/TypoEntry';
import ReasonView from 'src/components/ui/ReasonView';

const EventCard = (props) => {
	const { head, description, sections = [] } = props;

	return (
		<Card>
			{head && (
				<Box p={2} pb={1.5}>
					<PlateHead {...head} />
				</Box>
			)}
			<CardContent sx={{ p: 2, pt: 0 }}>
				{description && (
					<>
						<Box mb={1}>
							<Typography fontSize={16}>{description}</Typography>
						</Box>
						<Divider />
					</>
				)}
				{sections.length > 0 && (
					<Stack sx={{ py: 2 }} gap={3}>
						{sections.map((section) => {
							const { id, title, status, reasons = [], typos = [] } = section;
							return (
								<Stack key={id} gap={0.5}>
									{title && (
										<Typography variant="subtitle2" color="text.secondary">
											{title}
										</Typography>
									)}
									{status && <StatusText {...status} />}
									{reasons.length > 0 && (
										<Stack spacing={0.5}>
											{reasons.map((reason) => {
												return <ReasonView key={reason.id} {...reason} />;
											})}
										</Stack>
									)}
									{typos.length > 0 && (
										<Stack gap={1}>
											{typos.map((item) => {
												return <TypoEntry key={item.id} {...item} />;
											})}
										</Stack>
									)}
								</Stack>
							);
						})}
					</Stack>
				)}
			</CardContent>
		</Card>
	);
};

EventCard.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	head: PropTypes.shape(PlateHead.propTypes),
	description: PropTypes.string,
	sections: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			reasons: PropTypes.arrayOf(PropTypes.shape(ReasonView.propTypes)),
			typos: PropTypes.arrayOf(PropTypes.shape(TypoEntry.propTypes)),
		}),
	),
};

export default EventCard;
